import React from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import eventSchedulingAssistantTab from "assets/images/event_scheduling_assistant.svg";
import shiftSchedulingAssistantTab from "assets/images/shift_scheduling_assistant.svg";
import StarIcon from "assets/images/web_traffic.svg";
import CalendarIcon from "assets/images/small_calendar_icon.svg";
import constants, { eventSchedulingTabStatus } from "../../../../constants";
import StaffIcon from "assets/images/mir_staff.svg";
import FindAvailabilityIcon from "assets/images/Find-Availability.svg";
import AutoApproveIcon from "assets/images/auto-approve.svg";
import DateTimeIcon from "assets/images/Web.svg";
import "../AddEvent.scss";
import styles from "../AddEvent.module.scss";
import { leaveClasses } from "accountOwner/pages/Scheduler/scheduler.function";

const InfoSection = ({ title, items = [], icon, children }) => (
  <div className="event_shift_container">
    <div className="d-flex align-items-center">
      {icon && <img src={icon} alt="section-icon" className="mr-2" />}
      <p className="info-section-title">{title}</p>
    </div>

    {children || (
      <ul className="help_unordered_list">
        {items.map((item, idx) => (
          <li key={idx} className="help_list">
            {item}
          </li>
        ))}
      </ul>
    )}
  </div>
);

function SchedulerAssistantInfoModal({
  t,
  isOpen,
  onClose,
  isShift,
  eventKey,
  activeTab,
}) {
  const schedulingTabImage = isShift
    ? shiftSchedulingAssistantTab
    : eventSchedulingAssistantTab;

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        <p className="title">
          {activeTab === eventSchedulingTabStatus.event
            ? t("helpGuide")
            : t("howItWorks")}
        </p>

        {activeTab === eventSchedulingTabStatus.event && (
          <div className="info_section_container">
            <InfoSection title="Events / Shifts" icon={CalendarIcon}>
              <div className="schedular_tab_image_wrapper">
                <img
                  src={schedulingTabImage}
                  alt="SchedulingAssistantTab"
                  className="schedular_tab_image"
                />
                <img
                  src={StarIcon}
                  alt="Highlight Icon"
                  className="star_icon"
                />
              </div>

              <ul className="help_unordered_list">
                <li className="help_list">
                  {t("scheduler.schedulerAssistantModalText1")}
                </li>
                <li>{t("scheduler.schedulerAssistantModalText2")}</li>
              </ul>
            </InfoSection>

            <InfoSection
              title="Staff Members & Roles"
              icon={StaffIcon}
              items={[t("scheduler.schedulerAssistantModalText3", eventKey)]}
            />

            <InfoSection
              title="Event Visibility & Access Options"
              icon={DateTimeIcon}
              items={[
                t("scheduler.schedulerAssistantModalText4", eventKey),
                t("scheduler.schedulerAssistantModalText5", eventKey),
              ]}
            />

            {!isShift && (
              <InfoSection
                title="Auto-Approve Join Requests"
                icon={AutoApproveIcon}
                items={[t("scheduler.schedulerAssistantModalText6", eventKey)]}
              />
            )}
          </div>
        )}
        {activeTab === eventSchedulingTabStatus.schedulingAssistant && (
          <div className="info_section_container">
            <InfoSection title="Select Staff" icon={StaffIcon}>
              <p className="help_list mt-md-3">
                {t("scheduler.schedulerAssistantModalText7", eventKey)}
              </p>
            </InfoSection>
            <InfoSection title="Find Availability" icon={FindAvailabilityIcon}>
              <p className="help_list mt-md-3">
                {t("scheduler.schedulerAssistantModalText8", eventKey)}
              </p>
              <ul className="help_unordered_list">
                <li className="help_list">
                  {t("scheduler.schedulerAssistantModalText9")}
                </li>
                <li className="help_list">
                  {t("scheduler.schedulerAssistantModalText10")}
                </li>
                <li className="help_list">
                  {t("scheduler.schedulerAssistantModalText11")}
                </li>
              </ul>
              <p className="help_list mt-md-3">
                {t("scheduler.schedulerAssistantModalText12", eventKey)}
              </p>
            </InfoSection>
            <InfoSection
              title="Date and Time"
              icon={DateTimeIcon}
              items={[
                t("scheduler.schedulerAssistantModalText13"),
                t("scheduler.schedulerAssistantModalText14"),
              ]}
            />
            <InfoSection title="Legends">
              <ul className={styles["view-color-list-help"]}>
                <li>
                  <div className={styles["color-box"]} />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("accountOwner.createdByYou")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={`${styles["color-box"]} ${styles["color-grey"]}`}
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("accountOwner.createdByOthers")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={`${styles["color-box"]} ${styles["color-blue"]}`}
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("accountOwner.eventsNotAccepted")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={`${styles["color-box"]} ${styles["color-orange"]}`}
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("accountOwner.busy")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={
                      styles["color-box"] +
                      " " +
                      styles[
                        leaveClasses(constants.agendaType.PENDINGLEAVE).main
                      ]
                    }
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("scheduler.agenda.pendingLeave")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={
                      styles["color-box"] +
                      " " +
                      styles[
                        leaveClasses(constants.agendaType.APPROVEDLEAVE).main
                      ]
                    }
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("scheduler.agenda.approvedLeave")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={`${styles["color-box"]} ${styles["light-purple-bg"]}`}
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("appointments")}{" "}
                  </div>
                </li>
                <li>
                  <div
                    className={`${styles["color-box"]} ${styles["light-green-bg"]}`}
                  />
                  <div className={styles["text-box"]}>
                    {" "}
                    {t("availableSlots")}{" "}
                  </div>
                </li>
              </ul>
            </InfoSection>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(SchedulerAssistantInfoModal);
